import { cn } from "../../lib/utils";
import { MySelect } from "./Select";

type PageSizeSelectorProps = {
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  min?: number;
  max?: number;
};

const PageSizeSelector: React.FC<PageSizeSelectorProps> = ({
  pageSize,
  onPageSizeChange,
  min = 5,
  max = 50,
}) => {
  const step = 5;

  const options = Array.from(
    { length: (max - min) / step + 1 },
    (_, i) => min + i * step
  );

  return (
    <div className="ml-2 flex items-center space-x-3 text-sm text-hColor">
      <span>Show</span>

      <MySelect<string>
        name="pageSize"
        id="pageSize"
        label=""
        options={options.map((o) => o.toString())}
        getValue={(option) => option}
        getName={(option) => option + " rows"}
        value={pageSize?.toString() || "0"}
        onChange={(val: string) => onPageSizeChange(Number(val))}
        className={cn(
          "text-sm text-hColor px-2",
          "bg-white rounded-md",
          "w-[90px] h-[35px] focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary z-[9999]"
        )}
      />
    </div>
  );
};

export default PageSizeSelector;
